// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__0WR2R","divider_line":"divider_divider_line__u3jXT","divider_logo":"divider_divider_logo__fEwcp"};